import { Skeleton } from '@/components/ui/skeleton'
import { ServiceVettingCriteriaVersionSelect } from '@/features/service-vetting/components/service-vetting-criteria-version-select'
import { useGetService } from '@/features/service-vetting/query/use-get-service.ts'
import type { Service } from '@/features/service-vetting/types.ts'
import { type TKey, useTranslation } from '@/translations/i18n'

const categoryToLabel = {
	photography: 'vetting:criteria.service.category.photography',
	private_chef: 'vetting:criteria.service.category.private_chef',
	prepared_meals: 'vetting:criteria.service.category.prepared_meals',
	catering: 'vetting:criteria.service.category.catering',
	personal_training: 'vetting:criteria.service.category.personal_training',
	massage: 'vetting:criteria.service.category.massage',
	spa_treatments: 'vetting:criteria.service.category.spa_treatments',
	haircare: 'vetting:criteria.service.category.haircare',
	makeup: 'vetting:criteria.service.category.makeup',
	nails: 'vetting:criteria.service.category.nails',
	generic: 'vetting:criteria.service.category.generic',
	boudoir_photography: 'vetting:criteria.service.category.photography'
} as const satisfies Record<NonNullable<Service['category']>['key_name'], TKey>

export const ServiceVettingHeaderEndSlot = ({
	vettingId
}: {
	vettingId: number
}) => {
	const { t } = useTranslation()
	const serviceQuery = useGetService(vettingId)
	return (
		<div className='flex items-center gap-2.5 text-sm'>
			{serviceQuery.isPending ? (
				<Skeleton height={20} width={130} />
			) : (
				serviceQuery.data?.category && (
					<span className='text-neutral-700'>
						{t('vetting:criteria.service.category.category_value', {
							category: t(
								categoryToLabel[
									serviceQuery.data.category.key_name
								]
							)
						})}
					</span>
				)
			)}
			<ServiceVettingCriteriaVersionSelect serviceId={vettingId} />
		</div>
	)
}
